import { Box, styled, Typography } from '@mui/material';

export const PdfContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isContractPreviewEnabled',
})(({ theme, isContractPreviewEnabled }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: !isContractPreviewEnabled && 'center',

  '& .k-pdf-viewer': {
    border: 'none',

    '& .k-toolbar': {
      justifyContent: 'flex-end',
    },
    '& .k-canvas': {
      backgroundColor: `${theme.palette.colors.actionBar} !important`,
      paddingTop: '24px',

      '&.k-overflow-auto': {
        /* Firefox-specific styles */
        '@-moz-document url-prefix()': {
          scrollbarWidth: 'none',
        },

        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },

      '& .k-pdf-viewer-pages': {
        '& .k-page': {
          backgroundColor: theme.palette.colors.actionBar,
          border: `1px solid ${theme.palette.colors.scrollOnPrimaryBackground}`,
          boxShadow: 'none',

          '&:first-child': {
            marginTop: 0,
          },
          '&:last-child': {
            marginBottom: 0,
          },
        },
      },
    },
  },

  '& #docAcceptanceCheckbox': {
    padding: '16px 0 80px',

    [theme.breakpoints.up('lg')]: {
      padding: '16px 0',
    },
  },

  '& .formButtonsContainer': {
    width: '100%',
    justifyContent: 'center',

    '.submitButton, .backButton': {
      width: '148px',

      [theme.breakpoints.up('md')]: {
        width: '212px',
      },
      [theme.breakpoints.up('lg')]: {
        width: '148px',
      },
    },
  },

  '& #loadingIndicatorContainer': {
    left: 0,
    bottom: 0,
  },

  [theme.breakpoints.up('lg')]: {
    position: 'static',

    '& .k-pdf-viewer': {
      '& .k-canvas': {
        paddingTop: 0,

        '&.k-overflow-auto': {
          /* Firefox-specific styles */
          '@-moz-document url-prefix()': {
            scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
            scrollbarWidth: 'thin',
          },
          '&::-webkit-scrollbar': {
            display: 'block',
            width: '6px',
            height: '6px',
          },
          '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
            borderRadius: '5px',
          },
        },

        '& .k-pdf-viewer-pages': {
          border: `8px solid ${theme.palette.colors.actionBar}`,
          '& .k-page': {
            border: `none`,
          },
        },
      },
    },

    '& .formButtonsContainer': {
      width: 'auto',
    },
  },
}));

export const ScreenInformation = styled(Typography)(({ theme, disabled }) => ({
  fontSize: '15px',
  fontWeight: 'normal',
  letterSpacing: 'normal',
  color: disabled
    ? theme.palette.colors.secondaryDisabledText
    : theme.palette.colors.onSecondaryAndDetailBackground,
  overflowY: 'auto',
}));

export const CheckboxContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '16px 0 80px',

  [theme.breakpoints.up('lg')]: {
    padding: '16px 0',
  },
}));

export const CheckboxText = styled(Typography)(({ theme, disabled }) => ({
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: disabled
    ? theme.palette.colors.secondaryDisabledText
    : theme.palette.colors.onSecondaryAndDetailBackground,
}));
